import type {
  StudentRowDto,
  StudentStatusDto,
  StudentsListDto,
} from '../../../lib/api/students.api';

// ─── La página Alumnos: filtrar y contar (puro, con test) ───────────────────
// El estado lo calcula el servidor (regla del dominio, student-status.ts); acá
// solo se filtra lo que ya llegó. Los fallecidos en el origen quedan ocultos
// salvo que se pida verlos, y las cifras de arriba siguen al mismo filtro.

export interface StudentsFilter {
  status: StudentStatusDto | 'all';
  program: string | 'all';
  query: string;
  showDeceased: boolean;
}

export const DEFAULT_FILTER: StudentsFilter = {
  status: 'all',
  program: 'all',
  query: '',
  showDeceased: false,
};

const fold = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

export function filterStudents(rows: readonly StudentRowDto[], f: StudentsFilter): StudentRowDto[] {
  const q = fold(f.query);
  return rows.filter((r) => {
    if (r.deceasedInSource && !f.showDeceased) return false;
    if (f.status !== 'all' && r.status !== f.status) return false;
    if (f.program !== 'all' && !r.programs.includes(f.program)) return false;
    if (!q) return true;
    const hay = fold(
      `${r.firstName} ${r.lastName} ${r.lastName} ${r.firstName} ${r.studentCode ?? ''}`,
    );
    return hay.includes(q);
  });
}

/** Las cifras de arriba: con o sin los fallecidos, según el filtro. */
export function countsFor(list: StudentsListDto, showDeceased: boolean) {
  return showDeceased ? list.counts.all : list.counts.withoutDeceased;
}

/** Los programas que aparecen, para el filtro. */
export function programsOf(rows: readonly StudentRowDto[]): string[] {
  return [...new Set(rows.flatMap((r) => r.programs))].sort((a, b) => a.localeCompare(b, 'es'));
}
